import store from '@/store';
// import router from "@/router";
import axios from 'axios';
const endpoint = '/api/krainaabc/subprofile/activity/time?device=www';

export function recordTime(id) {
    let time = 60000;
    var interval = 1;

    const recordInterval = setInterval(() => {
        let data = {};
        data.object_id = id;        
        data.interval = interval;

        axios
            .post(endpoint, data)
            .then((response) => {
                if (response.status === 200) {
                    interval = 1;
                } else {
                    interval++;
                }
                
                if(response.data && response.data.data) {
                    let remainingTime = response.data.data.remaining_time;
                    let playFrom = response.data.data.play_from;
                    let playTo = response.data.data.play_to;

                    if(!playFrom && !playTo) {
                        if(remainingTime === 15 || remainingTime === 14 && !store.getters.isTimeIsUpRemind) {
                            store.dispatch("setIsTimeIsUpRemind", true);
                        }
    
                        if(remainingTime === 0) {
                            store.dispatch("setIsTimeIsUp", true);
                        }
                    }
                } else {
                    this.$store.dispatch("activeSubProfile");
                }
            })
            .catch(()=>{
                store.dispatch("activeSubProfile");  

                // store.dispatch("logout");
                // router.push({
                //     name: "Home",
                //     path: "/",
                // });

                clearInterval(recordInterval);
            });
    }, time);

    return recordInterval;
}